<template>
    <a-drawer
        :visible="open"
        placement="right"
        title="Avisos"
        :width="400"
        :zIndex="900"
        @close="$emit('close')"
    >
        <p v-if="items.length === 0" class="announcements-empty">
            Nenhum aviso por enquanto
        </p>
        <ul v-else class="announcements-list">
            <li v-for="item in items" :key="item.id">
                <button
                    type="button"
                    class="announcements-item"
                    @click="$emit('open-item', item.id)"
                >
                    <span class="announcements-item-title">{{ item.title }}</span>
                    <span class="announcements-item-meta">
                        <span>{{ formatDate(item.published_at) }}</span>
                        <a-tag v-if="!item.seen" color="red">Novo</a-tag>
                    </span>
                </button>
            </li>
        </ul>
    </a-drawer>
</template>

<script>
/** ISO 8601 -> "dd/mm/aaaa" pelos 10 primeiros caracteres, sem passar por Date. */
export function formatAnnouncementDate(value) {
    const match = typeof value === "string" && value.match(/^(\d{4})-(\d{2})-(\d{2})/);
    return match ? `${match[3]}/${match[2]}/${match[1]}` : "";
}

export default {
    name: "AnnouncementsDrawer",
    props: {
        open: { type: Boolean, default: false },
        items: { type: Array, default: () => [] },
    },
    methods: {
        formatDate: formatAnnouncementDate,
    },
};
</script>

<style>
.announcements-empty {
    color: #8c8c8c;
    text-align: center;
    margin-top: 24px;
}
.announcements-list {
    list-style: none;
    margin: 0;
    padding: 0;
}
.announcements-item {
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 4px;
    text-align: left;
    padding: 12px;
    margin-bottom: 8px;
    border: 1px solid #e8e8e8;
    border-radius: 6px;
    background: #fff;
    cursor: pointer;
    transition: border-color 0.2s, background 0.2s;
}
.announcements-item:hover {
    border-color: #ff432d;
    background: #fafafa;
}
.announcements-item-title {
    font-weight: 600;
    color: #262626;
}
.announcements-item-meta {
    display: flex;
    align-items: center;
    gap: 8px;
    color: #8c8c8c;
    font-size: 12px;
}
</style>
